import * as React from 'react';
import * as style from './MonthGroup.css';
import { Month } from '../Month/Month';

import classnames from 'classnames';
import { TSelect } from '../../../common/types/options';

type ITMonthGroup = {
  months: TSelect[];
  onChangeMonth: (value: string) => void;
  currentMonth: string;
  ratingIsLoading: boolean;
};

export const MonthGroup: React.FC<ITMonthGroup> = ({ months, onChangeMonth, currentMonth, ratingIsLoading }) => {
  const resultYear = months.find(month => month.value.includes('12-31'));

  return (
    <div className={style['months-group']}>
      <div className={classnames(style['months'], ratingIsLoading && style['months-disabled'])}>
        {months.map(
          (month, index) =>
            !month.label.includes('Итоги') && (
              <Month {...month} key={index} checked={currentMonth} handleChecked={onChangeMonth} />
            ),
        )}
      </div>
      {resultYear && (
        <div className={classnames(style['months'], ratingIsLoading && style['months-disabled'])}>
          <Month {...resultYear} checked={currentMonth} handleChecked={onChangeMonth} />
        </div>
      )}
    </div>
  );
};
